import React from "react";
import EndUserLicense from "../components/EndUserLicense";

function EndUserLicensePage() {
  return <EndUserLicense />;
}

export default React.memo(EndUserLicensePage);
